/* Auto-rotate the product media gallery every 4s.
   Pauses on hover/touch, while the lightbox is open, when the tab is hidden,
   when the gallery is off-screen, and while a video slide is active. */
(() => {
  const INTERVAL = 4000;
  const RESUME_DELAY = 4000;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const init = (gallery) => {
    if (gallery.dataset.tsdcAutoplay) return;
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!list) return;
    gallery.dataset.tsdcAutoplay = 'on';

    const desktop = window.matchMedia('(min-width: 750px)');
    let paused = false;
    let visible = true;
    let resumeTimer = null;

    const allSlides = () => Array.from(list.querySelectorAll('.product__media-item'));
    const imageSlides = () => allSlides().filter((li) => !li.classList.contains('product__media-item--full'));

    const currentSlide = () => {
      if (desktop.matches) return list.querySelector('.product__media-item.is-active');
      // mobile: the slide nearest the current scroll position
      let best = null;
      let bestDist = Infinity;
      allSlides().forEach((li) => {
        const dist = Math.abs(li.offsetLeft - list.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = li; }
      });
      return best;
    };

    const advance = () => {
      const images = imageSlides();
      if (images.length < 2) return;
      const current = currentSlide();
      if (current && current.classList.contains('product__media-item--full')) return; // stay on a video
      const next = images[(images.indexOf(current) + 1) % images.length];
      if (!next || next === current) return;

      if (desktop.matches) {
        allSlides().forEach((li) => li.classList.remove('is-active'));
        next.classList.add('is-active');
        const thumb = gallery.querySelector(`[id^="GalleryThumbnails"] [data-target="${next.dataset.mediaId}"]`);
        if (thumb && typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumb);
      } else {
        list.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
      }
    };

    const pause = () => { paused = true; clearTimeout(resumeTimer); };
    const resumeLater = () => { clearTimeout(resumeTimer); resumeTimer = setTimeout(() => { paused = false; }, RESUME_DELAY); };

    gallery.addEventListener('mouseenter', pause);
    gallery.addEventListener('mouseleave', () => { paused = false; });
    gallery.addEventListener('touchstart', pause, { passive: true });
    gallery.addEventListener('touchend', resumeLater, { passive: true });
    gallery.addEventListener('click', () => { pause(); resumeLater(); });

    new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(gallery);

    setInterval(() => {
      if (paused || !visible || document.hidden) return;
      if (document.querySelector('product-modal[open]')) return;
      advance();
    }, INTERVAL);
  };

  const start = () => document.querySelectorAll('media-gallery').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
